/* eslint-disable */

declare var Object: any;
export interface DataFieldInterface {
  id?: string;
  name: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  libraryFunctionId?: string;
}

export class DataField implements DataFieldInterface {
  'id': string;
  'name': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  'libraryFunctionId': string;
  constructor(data?: DataFieldInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DataField`.
   */
  public static getModelName() {
    return 'DataField';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of DataField for dynamic purposes.
   **/
  public static factory(data: DataFieldInterface): DataField {
    return new DataField(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'DataField',
      plural: 'DataFields',
      path: 'data-fields',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        name: {
          name: 'name',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
        libraryFunctionId: {
          name: 'libraryFunctionId',
          type: 'string',
        },
      },
      relations: {},
    };
  }
}
